'use client';
import { cx } from '@mage-ui/styled-system/css';
import { gridCol } from '@mage-ui/styled-system/recipes';

export const GridCol = ({ children, className, ...props }) => {
  return (
    <div className={cx(gridCol(), className)} {...props}>
      {children}
    </div>
  );
};
